<div class="flex flex-row justify-between">
    <p-breadcrumb
        [model]="[]"
        [home]="home"
    />
</div>

<p-table
    [value]="this.categoryArr"
    showGridlines
    scrollHeight="calc(100svh - 106px - 1.5rem)"
>
    <ng-template #header>
        <tr>
            <th class="w-[75%]">Kategorie</th>
            <th class="w-px"></th>
        </tr>
    </ng-template>
    <ng-template
        #body
        let-category
    >
        <tr>
            <td>
                {{ category }}
            </td>
            <td>
                <div class="text-right pe-5">
                    <i
                        class="pi pi-ellipsis-h cursor-pointer"
                        (click)="this.onContextMenu($event, category)"
                    ></i>
                    <p-contextmenu
                        #cm
                        appendTo="body"
                    />
                </div>
            </td>
        </tr>
    </ng-template>
</p-table>